import { createSelector } from 'reselect';
import get from 'lodash/get';

import { SCOPE } from './types';

const selector = state => get(state, SCOPE);

export const aiCustomisationVisibilitySelector = createSelector(selector,
  state => state.aiCustomModalVisible);

export const manualCustomisationVisibilitySelector = createSelector(selector,
  state => state.manualCustomModalVisible);

export const nameSelector = createSelector(selector,
  state => state.config.name);

export const emailsSelector = createSelector(selector,
  state => state.config.emails);

export const configIdSelector = createSelector(selector,
  state => state.config.configId);

export const partnerDetailsSelector = createSelector(selector,
  (state) => {
    const {
      partnerId,
      partnerName,
    } = state.config;

    return { partnerId, partnerName };
  });

export const defaultFieldsSelector = createSelector(selector,
  state => state.config.defaultFields);

export const aiConfigSelector = createSelector(selector,
  state => state.config.alertConfig.aiConfig);

export const manualConfigSelector = createSelector(selector,
  state => state.config.alertConfig.maConfig);

export const aiConfigCustomFieldSelector = createSelector(aiConfigSelector,
  (aiConfig) => {
    /*
    converts custom fields stored as array of objects to object of objects with 0, 1, 2.. as keys
    this was done because rendering dynamically generated arrays was tricky
    as there was no fixed index across renders, that could be used as a key in the render loop
    */
    const obj = Object.assign({}, aiConfig.customFields);
    return obj;
  });

export const manualConfigCustomFieldSelector = createSelector(manualConfigSelector,
  (manualConfig) => {
    /*
    converts custom fields stored as array of objects to object of objects with 0, 1, 2.. as keys
    this was done because rendering dynamically generated arrays was tricky
    as there was no fixed index across renders, that could be used as a key in the render loop
    */
    const obj = Object.assign({}, manualConfig.customFields);
    return obj;
  });

export const alertTypeSelector = createSelector(selector,
  state => state.config.alertType);

export const verifyConfigPayloadSelector = createSelector(selector,
  (state) => {
    const configuration = state.config;
    const integrationType = configuration.partnerName;
    const config = configuration.defaultFields.reduce((acc, cv) => {
      const newAcc = { ...acc };
      newAcc[cv.name] = cv.value;
      return newAcc;
    }, {});

    return {
      integration_type: integrationType,
      config,
    };
  });

export const saveConfigPayloadSelector = createSelector(selector,
  state => ({
    configuration: state.config,
  }));

export const showVerifyDialogSelector = createSelector(selector,
  state => state.showVerifyDialog);

export default selector;
